import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/saunter-haus-logo.svg";
import { primaryNavigation, inquiryNavigation } from "../siteNavigation";

export default function GlobalHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const dialogRef = useRef(null);

  function containTabFocus(event) {
    if (event.key !== "Tab") return;
    const controls = dialogRef.current.querySelectorAll("a[href], button:not([disabled])");
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  useEffect(() => {
    if (!mobileOpen) return;
    const dialog = dialogRef.current;
    dialog.showModal();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const desktop = window.matchMedia("(min-width: 1024px)");
    function closeOnDesktop(event) {
      if (event.matches) setMobileOpen(false);
    }
    desktop.addEventListener("change", closeOnDesktop);
    return () => {
      document.body.style.overflow = previousOverflow;
      desktop.removeEventListener("change", closeOnDesktop);
      dialog.close();
    };
  }, [mobileOpen]);

  return (
    <>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <aside className="studio-announcement" aria-label="Studio note">Interiors, thoughtfully considered.</aside>
      <header className="studio-header sticky top-0 z-40 w-full px-4 sm:px-6 py-4">
        <div className="header-inner mx-auto grid max-w-7xl items-center gap-4">
          <nav aria-label="Main navigation" className="hidden lg:flex items-center text-xs uppercase">
            {primaryNavigation.map((item) => (
              <Link key={item.label} to={item.href} className="hover:underline hover:underline-offset-4">{item.label}</Link>
            ))}
          </nav>
          <button className="lg:hidden p-2 justify-self-start" aria-label="Open navigation" aria-expanded={mobileOpen} aria-controls="mobile-navigation" onClick={() => setMobileOpen(true)}>
            <Menu className="h-5 w-5" />
          </button>
          <Link to="/" className="header-logo shrink-0 justify-self-center">
            <img src={logo} alt="Saunter Haus" className="h-8 object-contain" />
          </Link>
          <div className="justify-self-end">
            <Link to={inquiryNavigation.href} className="inquire-button hidden sm:inline-flex px-5 py-3 text-xs uppercase text-white">{inquiryNavigation.label}</Link>
          </div>
        </div>
      </header>
        <dialog ref={dialogRef} id="mobile-navigation" aria-label="Site navigation" className="mobile-navigation fixed inset-0 z-50 px-6 py-5" onKeyDown={containTabFocus} onCancel={(event) => { event.preventDefault(); setMobileOpen(false); }}>
          <div className="mobile-navigation-heading">
            <Link to="/" className="header-logo" onClick={() => setMobileOpen(false)}><img src={logo} alt="Saunter Haus" className="h-8 object-contain" /></Link>
            <button aria-label="Close navigation" className="p-2 justify-self-end" autoFocus onClick={() => setMobileOpen(false)}><X className="h-5 w-5" /></button>
          </div>
          <nav aria-label="Mobile navigation" className="mt-12 flex flex-col gap-6 text-sm uppercase">
            {primaryNavigation.map((item) => <Link key={item.label} to={item.href} onClick={() => setMobileOpen(false)}>{item.label}</Link>)}
            <Link to={inquiryNavigation.href} onClick={() => setMobileOpen(false)} className="inquire-button mt-4 px-4 py-3 text-center text-white">{inquiryNavigation.label}</Link>
          </nav>
        </dialog>
    </>
  );
}
